import { render, staticRenderFns } from "./old_view_v1.vue?vue&type=template&id=11ff1fca&scoped=true"
import script from "./old_view_v1.vue?vue&type=script&lang=js"
export * from "./old_view_v1.vue?vue&type=script&lang=js"
import style0 from "./old_view_v1.vue?vue&type=style&index=0&id=11ff1fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ff1fca",
  null
  
)

export default component.exports